/* eslint-disable quotes */
import { Sections } from '../components/sections'

export const TermsConditions = (): JSX.Element => {
  const sections = [
    { title: 'IMPORTANT LEGAL DISCLAIMER' },
    {
      title: 'RISKS OF PRODUCT USE',
      content: (
        <div>
          {
            'This website’s content is not a substitute for direct, personal, professional medical care and diagnosis. None of the exercise programs should be performed or otherwise used without clearance from your physician or health care provider first. The information contained within is not intended to provide specific physical or mental health advice, or any other advice whatsoever, for any individual or company and should not be relied upon in that regard. We are not medical professionals and nothing on this website should be misconstrued to mean otherwise.'
          }
          <br />
          <br />
          {
            'There may be risks associated with participating in activities mentioned on our site for people in poor health or with pre-existing physical or mental health conditions. If you are in poor health or have a pre-existing mental or physical condition. If you choose to participate in these risks, you do so of your own free will and accord, knowingly and voluntarily assuming all risks associated with such dietary activities. These risks may also exist for those who are currently in good health right now.'
          }
          <br />
          <br />
          {
            'As with any exercise program, you assume certain risks to your health and safety. Any form of exercise program can cause injuries, and our programs are no exception. It is possible that you may become injured doing the exercises in your program, especially if they are done with poor form. Although thorough instruction is included on the form for each exercise.'
          }
          <br />
          <br />
          {
            'Be aware that our programs (like any other exercise program) do involve a risk of injury. If you choose to participate in these risks, you do so of your own free will and accord, knowingly and voluntarily assuming all risks associated with such exercise activities. These risks may also exist for those who are currently in good health right now.'
          }
          <br />
          <br />
          {
            "We are not medical practitioners. Our advice whether it be on our website, in our meal plans, exercise program's or via email coaching, none of it is meant as a substitute for medical advice. You must consult your doctor before beginning ANY exercise program, with no exceptions. You are using our plans, programs, workout's and coaching at your own risk and we are not responsible for any injuries or health problems you may experience or even death as a result of using our programs."
          }
          <br />
          <br />
          {
            'It is to be made clear that we are not responsible for any injuries or health problems you may experience or even death as a result of using any of our products or services.'
          }
          <br />
        </div>
      ),
    },
    {
      title: 'GENERALLY EXPECTED RESULTS',
      content: (
        <div>
          {
            'Although our products and services are intended to be fully implemented, sometimes they are not, which could result in a lack of progress/results for the user. If you implement the products and services from us correctly you should see amazing results, however, it must be disclaimed that even when consumers implement any products or services in full from us it is still possible they will not get the results they may have expected and it is also possible they will not lose fat or gain muscle or achieve any positive results of any kind.'
          }
        </div>
      ),
    },
    {
      title: 'TESTIMONIAL DISCLAIMER',
      content: (
        <div>
          {
            'All the transformations and testimonials are real. However, it must be disclaimed that these testimonials are not claimed to represent typical results with our workout programs. They are meant as a showcase of what the most motivated and dedicated people can achieve by following our workout programs. Your results may vary and you may not get the same results compared to someone else when using our services due to differences in your individual exercise history, genetics, and personal motivation/dedication. The end results you get will depend upon the individual and how much effort you put in.'
          }
        </div>
      ),
    },
    {
      title: 'CANCELLATION & PACKAGE POLICY',
      content: (
        <div>
          {'1. Monthly Packages'}
          <ul>
            <li>{'All coaching and training packages are on a monthly basis.'}</li>
            <li>
              {'All sessions must be used within the same calendar month they are purchased.'}
            </li>
            <li>
              {'Sessions cannot be carried over into the next month under any circumstances.'}
            </li>
          </ul>
          {'2. Missed Sessions'}
          <ul>
            <li>
              {
                'Any sessions missed due to sickness or holidays must be rearranged within the same month by the client.'
              }
            </li>
            <li>
              {
                "It is the client's responsibility to reorganize missed sessions within that period."
              }
            </li>
          </ul>
          {'3. Payments'}
          <ul>
            <li>
              {
                'Payments for all monthly packages must be made on the 1st of each month in advance of sessions commencing.'
              }
            </li>
          </ul>
          {'4. Prolonged Sickness'}
          <ul>
            <li>
              {
                'In the event of prolonged illness, arrangements may be discussed on a case-by-case basis. Proof of illness may be requested.'
              }
            </li>
          </ul>
          {'5. Cancellations & Re-scheduling (1:1 or Hybrid Training)'}
          <ul>
            <li>{"24 hours' notice is required to rearrange any booked session."}</li>
            <li>
              {
                "Failure to provide 24 hours' notice will result in the session being charged in full and counted as taken."
              }
            </li>
            <li>{'All payments are to be made prior to appointments and in full.'}</li>
          </ul>
          {'6. Trainer Cancellations'}
          <ul>
            <li>{'If the trainer must cancel a session, that session will be reorganized.'}</li>
            <li>{'The rearranged session must be used within a maximum period of two months.'}</li>
          </ul>
        </div>
      ),
    },
  ]

  return <Sections heading='Terms & Conditions' sections={sections}></Sections>
}
